import { Component, OnInit, ViewChild } from '@angular/core';
import { IglesiasService } from '../../../../services/iglesias/iglesias.service';
import { MatTableDataSource, MatPaginator, MatDialog, MatSnackBar } from '@angular/material';
import { Church } from '../../../../models/church.model';
import { ConfirmComponent } from '../../../../components/confirm/confirm.component';

@Component({
  selector: 'app-iglesias-pendientes',
  templateUrl: './iglesias-pendientes.component.html',
  styleUrls: ['./iglesias-pendientes.component.scss']
})
export class IglesiasPendientesComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  pendingChurches: Church[] = [];
  displayedColumns: string[] = ['church', 'city', 'sectional', 'district', 'approve', 'delete'];
  dataSource: MatTableDataSource<Church>;

  resourcesHasLoaded: boolean = false;

  constructor(private _iglesiasService: IglesiasService, private dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit() {

    this._iglesiasService.getPendingChurches()
      .subscribe((data: Church[]) => {

        this.pendingChurches = data;

        this.dataSource = new MatTableDataSource<Church>(this.pendingChurches);
        this.dataSource.paginator = this.paginator;

        this.resourcesHasLoaded = true;
      }, (error) => {
        console.log('Hubo un error');
      })
  }

  approveChurch(id: number) {

    const ref = this.dialog.open(ConfirmComponent, { data: { title: 'Aprobar iglesia', content: '¿Está seguro de aprobar la iglesia? Posteriormente podrá actualizar sus datos', btnAgree: 'Aprobar', btnDisagree: 'Cancelar' } });

    ref.afterClosed()
      .subscribe((response: { return: boolean }) => {


        if (response.return) {
          this._iglesiasService.approveChurch(id)
            .subscribe((data) => {

              this.snackBar.open('Iglesia aprobada exitósamente', 'Cerrar', {
                duration: 3000
              });

              for (let i = 0; i < this.pendingChurches.length; i++) {
                if (this.pendingChurches[i].id == id) {
                  this.pendingChurches.splice(i, 1);
                }
              }

              this.dataSource.data = this.pendingChurches;

            })
        }
      })
  }

  rejectChurch(id: number) {
    const ref = this.dialog.open(ConfirmComponent, { data: { title: 'Rechazar iglesia', content: '¿Está seguro de rechazar la iglesia? Además se eliminará el usuario asociado a ella', btnAgree: 'Rechazar', btnDisagree: 'Cancelar' } });

    ref.afterClosed()
      .subscribe((response: { return: boolean }) => {


        if (response.return) {
          this._iglesiasService.deleteChurch(id)
            .subscribe((data) => {

              this.snackBar.open('Iglesia rechazada exitósamente', 'Cerrar', {
                duration: 3000
              });

              for (let i = 0; i < this.pendingChurches.length; i++) {
                if (this.pendingChurches[i].id == id) {
                  this.pendingChurches.splice(i, 1);
                }
              }

              this.dataSource.data = this.pendingChurches;

            }, (error) => {
              console.log('Ocurrió un error');

              this.snackBar.open('Ocurrió un error, debe asignar al miembro de esta iglesia en otra', 'Cerrar', {
                duration: 3000
              });

            });
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/iglesias-pendientes/iglesias-pendientes.component.ts